import { useDataIsSubmitting, useDataValue } from 'Simple/Data.js'

export function useDisabled(props) {
  let files = useDataValue({
    context: 'import',
    path: 'files',
    viewPath: props.viewPath,
  })
  let isSubmitting = useDataIsSubmitting({
    context: 'import',
    viewPath: props.viewPath,
  })

  return files.length === 0 || isSubmitting
}
